import { ref, watch, nextTick, unref } from 'vue';
import { useReportStore } from '@/stores/report.js';
import { showToast } from '@tarojs/taro';
import { SYSTEM_ID, DATA_FLAG, SYSTEM_BATCH_FORM_STORAGE } from '@/constants/index.ts'
import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '@/tool/localStore.ts';


export function useReportMethods() {
  const peportStore = useReportStore();

  // 获取所有表单的ref
  async function getRefs(refEl) {

    if (!refEl.value?.length) {
      return []
    }

    try {
      // 等待DOM更新完成
      await nextTick();
      const refs = unref(refEl);

      if (!Array.isArray(refs)) {
        throw new Error('refEl is not an array');
      }


      // 过滤并提取有效的refs
      const validRefs = refs?.filter(item => Array.isArray(item) && item.length > 0)
        ?.map(item => item[0]);
      return validRefs;
    } catch (error) {
      console.error('获取ref错误:', error);
      throw error; // 抛出错误以允许调用者处理
    }
  }


  // 获取表单中的 鱼池 或者 动态表单
  function getFishPond(refs, batchId, systemId, callBack) {
    let formItem = [];
    return new Promise((resolve, jeject) => {
      try {
        refs?.forEach(item => {
          if (
            typeof item?.getFishPond === 'function' ||
            typeof item?.getFormData === 'function'
          ) {
            callBack?.(item)
            item?.getFishPond?.(batchId.value, systemId.value);
            item?.getFormData?.(batchId.value, systemId.value);

            // 🔧 新增：强制同步数据到 store，确保最新数据被保存
            if (typeof item?.forceSyncToStore === 'function') {
              item.forceSyncToStore();
            } else if (typeof item?.syncToReportStore === 'function') {
              item.syncToReportStore();
            }
          }
          formItem.push(item)
        });
        resolve(formItem)
      } catch (error) {
        jeject(error)
      }
    })

  }


  // 验证表单
  function validateForms(refs) {
    // 创建一个数组来存储所有的验证错误
    let allErrors = [];




    return new Promise(async (resolve, reject) => {
      for (const item of refs) {
        try {
          const { valid, errors } = await item?.formRef?.validate();

          if (!valid) {
            // 如果默认验证失败，记录错误信息但不返回
            allErrors.push({ success: false, item, errors });
            continue;
          }



          /************验证备用代码 start**********/
          // if (item?.independentField) {
          //   let customErrors = [];
          //   let { model, modelName, data, tipsFields } = item?.independentField;


          //   // 自定义验证逻辑
          //   tipsFields.forEach(rule => {
          //     const { fieldName, field, tipsLabel } = rule;
          //     // 根据规则验证 data.value 中的数据
          //     const invalidItems = data.value.filter(
          //       item => !item[field] && item.queue != 'all'
          //     );

          //     if (invalidItems.length > 0) {
          //       invalidItems.forEach(item => {
          //         const errorMessage = `${modelName}-${fieldName}-${item.fishpondCode}-${tipsLabel}不能为空`;
          //         customErrors.push({ message: errorMessage });
          //       });
          //     }
          //   });

          //   // 如果有自定义错误，则添加到 allErrors 数组中
          //   if (customErrors.length > 0) {
          //     allErrors.push({
          //       success: false,
          //       item: { name: model },
          //       errors: customErrors,
          //     });
          //   }
          // }
          /************验证备用代码 end**********/



        } catch (error) {
          console.error('验证过程中发生错误 2222:', error);
          allErrors.push({ success: false, item, error });
          reject(allErrors)

        }
      }

      // 最后根据 allErrors 判断是否全部成功
      if (allErrors.length === 0) {
        resolve({ success: true })
      } else {
        // 返回第一个验证失败的结果（保持原始格式）
        resolve(allErrors[0])
      }
    })
  }


  // 检测一个对象中是否有值，可以排除指定属性
  function validateAndReturnObject(obj, excludeFields = []) {
    // 确保传入的是一个有效的对象
    if (typeof obj !== 'object' || obj === null) {
      return null;
    }

    // 创建 Set 用于快速查找排除字段
    const excludeSet = new Set(excludeFields);

    // 遍历对象的键值对
    for (const key of Object.keys(obj)) {
      // 如果当前键不在排除列表中，并且对应的值不是空，则返回对象
      if (!excludeSet.has(key) && obj[key] != null && obj[key] !== '') {
        return obj;
      }
    }

    // 如果没有找到任何非空字段，返回 null
    return null;
  }

  // 提交后清空数据
  function sbmitResetForm(data, refs) {
    let { batchId, systemId } = data;
    let reSetForm = refs[0]?.reSetForm
    peportStore.resetData(batchId, systemId)
  }

  // 删除图片和存储图片操作
  function OperationImage(data) {
    const { type, data: payload, formName, index } = data || {};

    console.log('OperationImage', data);


    return
    const getData = (type) => {
      let res = peportStore.optionsFiles('get', [], type)
      return res
    };
    if (type === 'get') return getData(formName);
    if (type === 'set') {
      peportStore.optionsFiles(type, dataOrIndex, formName);
    }

    if (type === 'del') {
      try {
        const list = getData(formName) || [];
        // 计算唯一 key
        const getKey = (item = {}) =>
          item.filePath || item.accessUrl || item.url || `${item.uid || ''}-${item.name || ''}`;
        let delIdx = -1;
        // 1) 优先根据 file 精确删除
        if (payload && payload.file) {
          const key = getKey(payload.file);
          delIdx = list.findIndex(it => getKey(it) === key);
        }
        // 2) 回退使用明确传入的 index
        if (delIdx === -1 && typeof index === 'number') delIdx = index;
        // 3) 回退使用 data 为数字索引
        if (delIdx === -1 && typeof payload === 'number') delIdx = payload;
        if (delIdx > -1 && delIdx < list.length) {
          list.splice(delIdx, 1);
        }
      } catch (e) {
        console.warn('删除附件失败（忽略，不中断流程）:', e);
      }
      return;
    }


  };

  // 设置数据暂存
  function dataTemporaryStorage(type = 'set', options = {}) {
    const { applyToStore = true } = options || {};
    // 读取是否选择了上报类型
    // 强制从持久化存储读取，避免命中内存缓存造成回显失败
    let dataFlag = getLocalStorage(DATA_FLAG, true);

    // 设置数据暂存
    if (type == 'set') {
      if (dataFlag?.length) {
        // 设置当前批次 系统 到本地，便于下次读取去替换对应的数据
        let selectedContext = peportStore.getSelectedContext;
        setLocalStorage(SYSTEM_ID, selectedContext);
        // 获取当前批次/系统的数据详情（getter 返回函数，需要再次调用）
        const getter = peportStore.fetchDataByBatchAndSystem();

        const getBatchSystemData = typeof getter === 'function' ? getter() : getter;

        console.log('getBatchSystemData', getBatchSystemData);
        setLocalStorage(SYSTEM_BATCH_FORM_STORAGE, getBatchSystemData);
        console.log('dataTemporaryStorage', dataFlag, getBatchSystemData);
        // 提示暂存成功
        showToast({
          title: '已暂存',
          duration: 2000,
        });
      } else {
        showToast({
          // 设置换行

          title: '暂存失败！\n 上报类型为空！',
          icon: 'none',
          duration: 2000,
        });
      }
    }

    // 获取数据暂存
    if (type == 'get') {
      // 上报类型有数据表示有暂存 SYSTEM_ID
      if (dataFlag?.length) {
        // 获取缓存批次 id 系统 id  code 等，设置到pinia中
        let getBatchSystemId = getLocalStorage(SYSTEM_ID, true);
        const { batchId, systemId, batchCode, systemCode } = getBatchSystemId;
        // 获取缓存批次 系统 表单详情
        let getBatchSystemData = getLocalStorage(SYSTEM_BATCH_FORM_STORAGE, true);

        if (applyToStore) {
          // 保护：确保 batchId/systemId 存在，且先建立选中上下文
          if (batchId && systemId) {
            peportStore.setCurrentSelectTarget(getBatchSystemId)
            peportStore.loadAndReplaceCachedFormData(batchId, systemId, getBatchSystemData)
          } else {
            console.warn('读取暂存但缺少 batchId/systemId，已跳过写入 store:', getBatchSystemId)
          }
        }
        return {
          hasCache: Boolean(dataFlag?.length),
          peportTypeContnet: dataFlag,
          prportypeValue: dataFlag?.map(item => item.value),
          batchSystemData: getBatchSystemData,
          batchId,
          batchCode,
          systemId,
          systemCode
        }
      }
    }
    // 移除数据暂存
    if (type == 'clear') {
      removeLocalStorage(SYSTEM_ID);
      removeLocalStorage(DATA_FLAG);
      removeLocalStorage(SYSTEM_BATCH_FORM_STORAGE);
    }
  };

  // 修复缓存数据中的图片URL，将blob URL替换为accessUrl
  function fixCacheImageUrls(cacheData) {
    if (!cacheData || !cacheData.batchSystemData) {
      return cacheData;
    }

    const batchSystemData = cacheData.batchSystemData;

    // 修复图片URL的工具函数
    const fixImageUrls = (fileList) => {
      if (!Array.isArray(fileList)) return fileList;

      return fileList.map(file => {
        // 如果url是blob URL且存在accessUrl，则使用accessUrl替换
        if (file.url && file.url.startsWith('blob:') && file.accessUrl) {
          return {
            ...file,
            url: file.accessUrl
          };
        }
        return file;
      });
    };

    // 需要处理的字段列表
    const fieldsToFix = [
      'lossRequest',
      'feedingRequest',
      'medicationRequest',
      'aquaMedication',
      'waterRequest',
      'growthSituationRequest',
      'healthRecordRequest',
      'inspectionReportRequest',
      'environmentRecordRequest',
      'microscopicRequest'
    ];

    // 遍历所有表单数据，修复其中的图片URL
    fieldsToFix.forEach(fieldName => {
      if (batchSystemData[fieldName] && batchSystemData[fieldName].uploadFiles) {
        batchSystemData[fieldName].uploadFiles = fixImageUrls(batchSystemData[fieldName].uploadFiles);
      }
    });


    return cacheData;
  }

  return {
    getRefs,
    getFishPond,
    validateForms,
    validateAndReturnObject,
    sbmitResetForm,
    OperationImage,
    dataTemporaryStorage,
    fixCacheImageUrls
  }


}